import Button from '@components/atoms/button'
import BookFreeClassBtn from '@components/common/book-free-class-btn'
import { FastlyImage } from '@components/common/image'
import dynamic from 'next/dynamic'
import { useState } from 'react'
const StemAccrediatedModal = dynamic(() =>
  import('@components/curriculum/stem-accrediated-modal')
)

const IMAGE_PATH = '/images/curriculum/'

const StemAccrediated = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <div
      className="relative z-0 pt-12 mt-6 overflow-hidden"
      style={{
        background: '#FFFAFA',
      }}
    >
      <div className="px-10">
        <h3 className="text-2xl leading-tight text-center text-grey font-700 lg:text-4xl">
          STEM.org Accredited Educational Experience
        </h3>
        <div className="flex justify-center mt-10">
          <FastlyImage
            src={`${IMAGE_PATH}stem-accrediated.png`}
            webpSrc={`${IMAGE_PATH}stem-accrediated.webp`}
            alt="STEM accredited online coding course"
            height={107}
            width={237}
          />
        </div>
        <div className="flex flex-col lg:mt-8">
          <div className="flex flex-col justify-center lg:flex-row">
            <div className="lg:w-1/3 py-5 lg:mx-5">
              <div className="flex items-center justify-center mb-3 md:h-16">
                <h3 className="text-2xl font-700">What is STEM.org?</h3>
              </div>
              <p className="text-center">
                STEM.org Educational Research (SER) is the longest continually
                operating STEM education research and credentialing organization
                that has served over 4,500 schools, districts, and organizations
                in over 25 countries.
              </p>
            </div>
            <div className="lg:w-1/3 py-5 lg:mx-5">
              <div className="flex items-center justify-center mb-3 md:h-16">
                <h3 className="text-center text-2xl font-700">
                  Who gets STEM.org Accreditation?
                </h3>
              </div>
              <p className="text-center">
                The STEM.org Accreditation is awarded to institutions that
                develop 21st century skills, have an original curriculum
                revolving around STEM, adequately incorporate technology into
                classes, and offer hands-on STEM-based activities.
              </p>
            </div>
            <div className="lg:w-1/3 py-5 lg:mx-5">
              <div className="flex items-center justify-center mb-3 md:h-16">
                <h3 className="text-center text-2xl font-700">
                  What does STEM.org Accreditation mean?
                </h3>
              </div>
              <p className="text-center">
                STEM.org Accreditation is awarded by STEM.org Educational
                Research (SER) after thoroughly examining and evaluating the
                educational institution&apos;s curriculum, teachers, and courses
                for efficiency, effectiveness, and quality.
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col justify-center py-8 space-y-4 lg:flex-row lg:space-y-0 lg:space-x-4">
          <Button variant="outline" onClick={() => setIsModalOpen(true)}>
            View certificate
          </Button>
          <BookFreeClassBtn />
        </div>
        {isModalOpen && (
          <StemAccrediatedModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
          />
        )}
      </div>
    </div>
  )
}

export default StemAccrediated
